import { ManageDeviceActionTypes } from "../actions/index.model";
import { Devices, DeviceState } from "./index.model";

const defaultState: DeviceState = {
  devices: [],
  loading: true,
  ownerId: "",
  statusCode: 0,
  success: false,
  error: "",
};

const ManageDevicesReducer = (
  state: DeviceState = defaultState,
  action: any
) => {
  switch (action.type) {
    case ManageDeviceActionTypes.GET_MANAGE_DEVICE_DETAILS:
      return { ...state, loading: true };
    case ManageDeviceActionTypes.UPDATE_MANAGE_DEVICES_DETAILS: {
      var result = action.data ? action.data : [];
      //UD-3172
      return {
        ...state,
        loading: false,
        statusCode: result.status,
        devices: result.data
          ? result.data.filter((device: Devices) => {
              return (
                device.applicationCategory.toLocaleLowerCase() !== "webclient"
              );
            })
          : [],
      };
    }
    case ManageDeviceActionTypes.UPDATE_SIGNOUT_DEVICE_DETAILS: {
      return {
        ...state,
        ownerId: action.data?.ownerId,
        success: action.data?.res
          ? action.data?.res === "404"
            ? false
            : action.data?.res
          : action.data?.res,
        error: action.data?.res
          ? action.data?.res === "404"
            ? "404"
            : ""
          : "error",
      };
    }
    case ManageDeviceActionTypes.RESET_SIGNOUT_DEVICE: {
      return {
        ...state,
        ownerId: "",
        success: false,
        error: "",
      };
    }
    default:
      return state;
  }
};
export default ManageDevicesReducer;
